<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-export
        :href="exportUrl"
        :beforeDownload="beforeDownload"
        style="margin: 0 0 0 8px"
        download="download.xls"
        value="导出"/>
      <input-select selectTitle="报表类型" :selectKey="'reportType'" :selectData="taskTypeList" @search="search" style="margin-left:10px"/>
        </el-date-picker>
      </div>
    <input-search placeholder="班组" @search="searchKey" />
    </div>

    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @toCurrentPage="toCurrentPage" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/KeepWatch";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "patrol-report",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧巡更",
          name: "patrol-point-manage"
        },
        {
          value: "巡更任务"
        }
      ],
      exportUrl: "",
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      tableHead: [
        {
          prop: "teamName",
          label: "班组"
        },
        {
          prop: "userCount",
          label: "班组人数"
        },
        {
          prop: "reportTypeText",
          label: "报表类型"
        },
        {
          prop: "taskCount",
          label: "巡更任务"
        },
        {
          prop: "completedTask",
          label: "按时完成"
        },
        {
          prop: "abnormalTask",
          label: "异常任务"
        },
        {
          prop: "reportTime",
          label: "报表时间"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      timeValue: [],
      requestData: {
        startTime: "",
        endTime: "",
        searchKey: "",
        reportType: ""
      },
      taskTypeList: [
        {
          label: "全部",
          key: ""
        },
        {
          label: "按日",
          key: 0
        },
        {
          label: "按月",
          key: 1
        },
        {
          label: "按年",
          key: 2
        }
      ]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportPatrolReport}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&reportType=${this.requestData.reportType}`;
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getPatrolReportPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;

            data.map(v => {
              if (v.reportType == 0) {
                v.reportTypeText = "按日";
              } else if (v.reportType == 1) {
                v.reportTypeText = "按月";
              }
            });

            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取记录失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    toCurrentPage(code) {
      this.$router.push({
        path: `/site_reservation/site_current/${code}`
      });
    },
    changeTimeValue() {}
  },

  watch: {
    timeValue() {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/KeepWatch/PatrolReport/PatrolReport.vue